// Module
var code = `<ex-multi-occurrence-maitre-details-ecran lbl-titre="LBL_TITRE_TPR" multi-occurrence-options="vm.multiOccurrenceOptions" multi-occurrence-out="vm.tprMultiOccurrence"> </ex-multi-occurrence-maitre-details-ecran> `;
// Exports
module.exports = code;